<!-- 评价列表 -->
<template>
  <div class="cgh-view">
    <cghhead title="评价列表"></cghhead>
    <div class="cgh-content">
      <div class="cgh-item-con" v-if="dataList.length != 0">
         <List v-model="loading" :immediate-check="false" :finished="finished" finished-text="没有更多了" @load="_getList">
          <evaluateItem :list="dataList"></evaluateItem>
        </List>
      </div>
      <Empty v-if="dataList.length == 0" description="空空如也~" ></Empty>
    </div>
  </div>
</template>

<script>
import cghhead from "@/components/headView/headView";
import evaluateItem from "@/components/evaluateItem/evaluateItem";
import { List, Empty, Toast } from "vant";
const posts = require("@/assets/mode/post.json");
export default {
  data() {
    return {
      id: '',
      dataList: [],
      // 分页
      loading: false,
      finished: false,
      pages: 0, // 总页数
      page: 0, // 当前页数
      pageSize: 10 // 每页大小
    };
  },
  created() {
    this.id = this.$route.query.id;
    this._getList();
  },
  methods: {
   _getList() {
      // 获取数据
      let tost = Toast.loading({
        message: '加载中...',
        forbidClick: true,
      });
      this.page++;
      let para = {id: this.id, page: this.page, limit: this.pageSize};
      this.$API.get('goods/evaluate_list', para).then(res => {
        if (res.status == 1) {
          try {
             let list = res.data.list;
            this.dataList = this.dataList.concat(list);
            this.pages = res.data.count;
            // 加载状态结束
            this.loading = false;
            // 数据全部加载完成
            if (this.dataList.length >= res.data.count || list.length == 0) {
              this.finished = true;
            }
          } catch (e) {
            this.finished = true;
          }
        }
        tost.clear();
      });
    },
  },
  components: {
    cghhead,
    evaluateItem,
    List,
    Empty
  }
};
</script>
<style lang='scss' scoped>
@import "@/assets/style/minxi.scss";
.cgh-view {
  overflow: hidden;
  width: 100%;
  .cgh-content {
    margin-top: 45px;
    overflow: hidden;
    .cgh-item-con {
      overflow: hidden;
    }
  }
  .van-empty {
    margin-top: 40%;
  }
}
</style>